import { makeStyles } from '@material-ui/core/styles';
<style>@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@1,700&display=swap');</style>

const useStyles = makeStyles((theme) => ({

    root: {
      display: 'flex',
      height: '100vh'
    },
    toolbar: {
      paddingRight: 24,
      borderBottom: '2px solid #000',
      boxShadow: theme.shadows[5],
      background: '#F5F5F5',
      backgroundColor: '#F5F5F5',
    },
    toolbarIcon: {
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
 
      }),
    },
    typography: {
      marginRight: '175px',
      width: '100%',
      textAlign: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'italic',
      fontWeight: 700,
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
      overscrollBehavior: 'none',
      background: 'radial-gradient(circle, rgba(48,76,178,1) 0%, rgba(26,44,128,1) 100%)',
      paddingTop: '100px'
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      overscrollBehavior: 'none',
    },
    fixedHeight: {
      height: '240',
    },
  }));

  export default  useStyles;
